import { DecimalPipe } from '@angular/common';
import type { PipeTransform } from '@angular/core';
import { Pipe, inject } from '@angular/core';
import type { OnyxOptional } from '@onyx/angular';

@Pipe({
  name: 'dimensions',
})
export class DimensionsPipe implements PipeTransform {
  private readonly decimalPipe = inject(DecimalPipe);

  public transform(
    dimensions: OnyxOptional<Record<'length' | 'width' | 'height', number>>,
  ): string {
    if (!dimensions) return '-';

    const format = (value: number, decimalPlaces = 2) =>
      this.decimalPipe.transform(value / 10 ** decimalPlaces, '1.0-2') ?? '??';

    return `${format(dimensions.length)} × ${format(dimensions.width)} × ${format(dimensions.height)} m`;
  }
}
